// extracted by mini-css-extract-plugin
module.exports = {"header":"triviaheader_header__3_-s7","title":"triviaheader_title__1QFyz","wrapper":"triviaheader_wrapper__GBud8","activelist":"triviaheader_activelist__2JtXz"};